{
  "title": "Activity Timeline",
  "empty": "No activity in this time range.",
  "today": "Today",
  "yesterday": "Yesterday",
  "window": {
    "24h": "24 hours",
    "3d": "3 days",
    "7d": "7 days"
  },
  "session": {
    "briefRun": "less than a minute",
    "pressure": {
      "ongoingWithDevice": "{{deviceName}} is pressurized",
      "completedWithDeviceAndDuration": "{{deviceName}} held pressure for {{duration}}"
    },
    "reel": {
      "ongoingWithDevice": "{{deviceName}} reel is running",
      "completedWithDeviceAndDuration": "{{deviceName}} reel ran for {{duration}}"
    },
    "relay": {
      "ongoingWithDevice": "{{deviceName}} relay is on",
      "completedWithDeviceAndDuration": "{{deviceName}} relay was on for {{duration}}"
    }
  },
  "transition": {
    "over_pressure": {
      "withDevice": "{{deviceName}} over-pressure alarm"
    }
  },
  "burst": {
    "over_pressure": {
      "withDeviceAndCount": "{{deviceName}}: {{count}} over-pressure alarms"
    }
  }
}
